function Stars() {
  return (
    <div className="flex items-center gap-0.5">
      {[1,2,3,4,5].map(i => <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>)}
    </div>
  );
}

const testimonials = [
  {
    text: "We had a family cruise booked out of Tampa and my husband realized his passport was expired two weeks before departure. Fast Passport Center got it back to our Lakeland home in 5 days. We were so relieved.",
    name: "Cheryl M.",
    location: "Lakeland, FL",
    service: "Renewal",
  },
  {
    text: "I work for Publix corporate and travel internationally frequently. Needed a second passport and FPC handled everything quickly and professionally — their courier access meant no personal travel to Miami, no stress.",
    name: "David R.",
    location: "Lakeland, FL",
    service: "Second Passport",
  },
  {
    text: "Our son is a Florida Poly student doing a semester abroad. We didn't know he needed a new passport since his expired. Fast Passport Center guided us through the whole process and had it delivered in under a week.",
    name: "Lisa T.",
    location: "Polk County, FL",
    service: "New Passport",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Lakeland Area Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Lakeland and Polk County travelers who trusted Fast Passport Center to handle their passport applications.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}